module.exports = __webpack_public_path__ + "img/hd_hvs.8f928150.png";